// tslint:disable:no-bitwise

export class RandomDataGenerator {
  private c: number = 1;
  private s0: number = 0;
  private s1: number = 0;
  private s2: number = 0;

  // tslint:disable-next-line:no-any
  constructor(seeds: any[] | string) {
    if (typeof seeds === 'string') {
      this.state(seeds);
    } else {
      this.sow(seeds);
    }
  }

  public rnd(): number {
    const t: number = 2091639 * this.s0 + this.c * 2.3283064365386963e-10;
    // tslint
    this.c = t | 0;
    this.s0 = this.s1;
    this.s1 = this.s2;
    this.s2 = t - this.c;
    return this.s2;
  }

  // tslint:disable-next-line:no-any
  public sow(seeds?: any[]): void {
    this.s0 = this.hash(' ');
    this.s1 = this.hash(this.s0);
    this.s2 = this.hash(this.s1);
    this.c = 1;

    if (!seeds) {
      return;
    }

    // Apply any seeds
    for (let i: number = 0; i < seeds.length && seeds[i] != null; i++) {
      // tslint:disable-next-line:no-any
      const seed: any = seeds[i];

      this.s0 -= this.hash(seed);
      this.s0 += ~~(this.s0 < 0);
      this.s1 -= this.hash(seed);
      this.s1 += ~~(this.s1 < 0);
      this.s2 -= this.hash(seed);
      this.s2 += ~~(this.s2 < 0);
    }
  }

  public shuffle<T>(array: T[]): T[] {
    for (let i: number = array.length - 1; i > 0; i--) {
      const j: number = Math.floor(this.rnd() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }

    return array;
  }

  public integer(): number {
    return this.rnd.apply(this) * 0x100000000;
  }

  public frac(): number {
    return this.rnd.apply(this) + ((this.rnd.apply(this) * 0x200000) | 0) * 1.1102230246251565e-16;
  }

  public real(): number {
    return this.integer() + this.frac();
  }

  public integerInRange(min: number, max: number): number {
    return Math.floor(this.realInRange(0, max - min + 1) + min);
  }

  public between(min: number, max: number): number {
    return this.integerInRange(min, max);
  }

  public realInRange(min: number, max: number): number {
    return this.frac() * (max - min) + min;
  }

  public normal(min: number, max: number): number {
    return 1 - 2 * this.frac();
  }

  public uuid(): string {
    let a: string = '';
    let b: string = '';

    for (
      b = a = '';
      // @ts-ignore
      a++ < 36;
      // @ts-ignore
      b += ~a % 5 | ((a * 3) & 4) ? (a ^ 15 ? 8 ^ (this.frac() * (a ^ 20 ? 16 : 4)) : 4).toString(16) : '-'
    ) {
      //
    }

    return b;
  }

  public pick<T>(array: T[]): T {
    return array[this.integerInRange(0, array.length - 1)];
  }

  public sign(): number {
    return this.pick([-1, 1]);
  }

  public weightedPick<T>(array: T[]): T {
    return array[~~(Math.pow(this.frac(), 2) * (array.length - 1) + 0.5)];
  }

  public timestamp(min: number, max: number): number {
    return this.realInRange(min || 946684800000, max || 1577862000000);
  }

  public angle(): number {
    return this.integerInRange(-180, 180);
  }

  public state(state?: string): string {
    if (typeof state === 'string' && state.match(/^!rnd/)) {
      const stateArray: string[] = state.split(',');

      this.c = parseFloat(stateArray[1]);
      this.s0 = parseFloat(stateArray[2]);
      this.s1 = parseFloat(stateArray[3]);
      this.s2 = parseFloat(stateArray[4]);
    }

    return ['!rnd', this.c, this.s0, this.s1, this.s2].join(',');
  }

  // tslint:disable-next-line:no-any
  private hash(data: any): number {
    let h: number;
    let i: number;
    let n: number = 0xefc8249d;

    // eslint-disable-next-line no-param-reassign
    data = data.toString();

    for (i = 0; i < data.length; i++) {
      n += data.charCodeAt(i);
      h = 0.02519603282416938 * n;
      n = h >>> 0;
      h -= n;
      h *= n;
      n = h >>> 0;
      h -= n;
      n += h * 0x100000000; // 2^32
    }

    return (n >>> 0) * 2.3283064365386963e-10; // 2^-32
  }
}
